import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Helmet } from 'react-helmet';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { fi } from 'date-fns/locale';
import { formatDateToFinnish } from '../../common/utils/dateUtils';
import { Loader, SectionHeader } from '../../common/components';
import { useAppDispatch } from '../../app/hooks';
import { generateSellStatsAsync, SellStatsCommand } from './accountingSlice';

function SellStats() {
  const dispatch = useAppDispatch();
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
  const [bookingNumber, setBookingNumber] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {}, []);
  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      setError(null);
    }
  }, [selectedStartDate, selectedEndDate]);

  const setLocalStartDate = async (date: Date) => {
    setSelectedStartDate(date);
  };

  const setLocalEndDate = async (date: Date) => {
    setSelectedEndDate(date);
  };
  const sellStatsCommandHandle = async () => {
    if (!selectedStartDate || !selectedEndDate) {
      setError('Valitse alkupäivä ja loppupäivä');
      return;
    }
    const finlandTimeZone = 'Europe/Helsinki';
    setIsLoading(true);
    try {
      const command = {
        startDate: formatDateToFinnish(selectedStartDate),
        endDate: formatDateToFinnish(selectedEndDate),
        bookingNumber,
      } as SellStatsCommand;
      await dispatch(generateSellStatsAsync(command));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Myyntikirja - Luonti</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Myyntikirja']}
          Title="Myyntikirjan luonti"
        />
        <Container className="container-form">
          {error && (
            <Alert className="mb-32" variant="danger">
              {error}
            </Alert>
          )}

          <Form.Group controlId="start" className="mb-24">
            <Form.Label>Raportin alkupäivä</Form.Label>
            <DatePicker
              locale={fi}
              required
              dateFormat="dd.MM.yyyy"
              showYearDropdown
              onChange={date => setLocalStartDate(date)}
              selected={selectedStartDate}
              id="start"
            />
          </Form.Group>
          <Form.Group controlId="end" className="mb-24">
            <Form.Label>Raportin loppupäivä</Form.Label>
            <DatePicker
              locale={fi}
              required
              dateFormat="dd.MM.yyyy"
              showYearDropdown
              onChange={date => setLocalEndDate(date)}
              selected={selectedEndDate}
              id="end"
            />
          </Form.Group>
          <Form.Group controlId="number" className="mb-24">
            <Form.Label>
              Varausnumero(valinnainen). Yksittäisen varauksen tarkasteluun
            </Form.Label>
            <input
              onChange={text => setBookingNumber(text.target.value)}
              className="form-control"
              value={bookingNumber}
              id="number"
            />
          </Form.Group>
          <Button
            onClick={sellStatsCommandHandle}
            variant="primary"
            className="w-100 mt-16"
            disabled={isLoading}
          >
            {isLoading ? <>Luodaan myyntikirjaa...</> : 'Luo myyntikirja'}
          </Button>
          {isLoading && (
            <div className="my-24">
              <Loader IsLoading />
            </div>
          )}
        </Container>
        {/* <Button */}
        {/*  onClick={downloadWintime} */}
        {/*  size="sm" */}
        {/*  variant="outline-blue" */}
        {/*  className="px-16" */}
        {/* > */}
        {/*  Lataa wintime aineisto Zip tiedostona */}
        {/* </Button> */}
      </Container>
    </>
  );
}

export default SellStats;
